import { BrandConfig } from '../constants/brandConfig';

const getDefaultAccommodationType = (brandConfig: BrandConfig) => brandConfig.accommodationTypes[0].value;

export default getDefaultAccommodationType;
